<template>
  <div style="border: 1px solid #ccc">
    <Toolbar
      style="border-bottom: 1px solid #dcdfe6; width: 100%; border-radius: 4px"
      :editor="editorRef"
      :defaultConfig="toolbarConfig"
      mode="default"
    />
    <Editor
      style="min-height: 300px"
      v-model="state.value"
      @onCreated="handleCreated"
      :default-config="editorConfig"
      @onChange="onChange"
    />
  </div>
</template>

<script>
import { onMounted, reactive, shallowRef, ref } from "vue";
import "@wangeditor/editor/dist/css/style.css"; // 引入 css
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { attachment_upload } from "@/http/attachment";
import attachmentModule from "@wangeditor/plugin-upload-attachment";

import { Boot } from "@wangeditor/editor";
Boot.registerModule(attachmentModule);

export default {
  props: {
    value: {
      type: String,
    },
  },
  components: {
    Editor,
    Toolbar,
  },
  setup(props, { emit }) {
    const state = reactive({
      loadContent: true,
    });
    const editorRef = shallowRef();
    const handleCreated = (editor) => {
      editorRef.value = editor; // 记录 editor 实例，重要！
      editor.on("preview", () => {
        emit("preview");
      });
    };

    const toolbarConfig = {};

    onMounted(() => {
      toolbarConfig.insertKeys = {
        index: 21, // 插入的位置，基于当前的 toolbarKeys
        keys: ["uploadAttachment"],
      };
      setTimeout(() => {
        state.value = props.value;
        state.loadContent = false;
      }, 1500);
    });

    const editorConfig = ref({
      placeholder: "请输入内容...",
      readOnly: false, // 只读
      MENU_CONF: {
        // 配置上传图片
        uploadImage: {
          async customUpload(file, insertFn) {
            const formData = new FormData();
            formData.append("file[]", file);
            attachment_upload(formData).then((res) => {
              if (res.status == 200) {
                const { data } = res.data;
                if (data.length > 0)
                  insertFn(
                    data[0].file_url,
                    data[0].origin_filename,
                    data[0].file_url,
                  );
              }
            });
          },
        },
        uploadVideo: {
          async customUpload(file, insertFn) {
            const formData = new FormData();
            formData.append("file[]", file);
            attachment_upload(formData).then((res) => {
              if (res.status == 200) {
                const { data } = res.data;
                if (data.length > 0) insertFn(data[0].file_url);
              }
            });
          },
        },
        uploadAttachment: {
          async customUpload(file, insertFn) {
            const formData = new FormData();
            formData.append("file[]", file);
            attachment_upload(formData).then((res) => {
              if (res.status == 200) {
                const { data } = res.data;
                if (data.length > 0)
                  insertFn(data[0].file_url, data[0].origin_filename, 200);
              }
            });
          },
        },
        preview: {
          customClick() {},
        },
      },
    });

    const onChange = (e) => {
      if (!state.loadContent) emit("change", e.getHtml());
    };

    return {
      state,
      props,
      handleCreated,
      editorRef,
      editorConfig,
      onChange,
      toolbarConfig,
    };
  },
};
</script>
<style scoped></style>
